import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Wed, 1 Nov 2024 10:55PM ( BRT ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.Dcz2fxzNIXw50J1ZgKFiohZh5XSJjdViyD1ybFM4LgtLgBpalG3NESSHCPGRx2wYrZblDShfjhc6lp-V0xHubwxOw2DA4vO9GEqdR8Lu1kVjD0lqym0QBK0y1nIVjwLGmapJ6md9DA_tID3607zm39fipPd8iE5sAjbWN0CSxOmJe9FiqucyMPVHfG37w-T8HHGcBoSKJT1Gh8yf-zKXPwWVNTjljlisO_c6zCk3wPKLxYnMMTBGk6IdPa4Xg13Hr-FgBTUxhguboqdfapP-8cN5hVAmwtE",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2024-11-09T01:56:33.880235Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2024-11-02T01:56:18+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.Dcz2fxzNIXw50J1ZgKFiohZh5XSJjdViyD1ybFM4LgtLgBpalG3NESSHCPGRx2wYrZblDShfjhc6lp-V0xHubwxOw2DA4vO9GEqdR8Lu1kVjD0lqym0QBK0y1nIVjwLGmapJ6md9DA_tID3607zm39fipPd8iE5sAjbWN0CSxOmJe9FiqucyMPVHfG37w-T8HHGcBoSKJT1Gh8yf-zKXPwWVNTjljlisO_c6zCk3wPKLxYnMMTBGk6IdPa4Xg13Hr-FgBTUxhguboqdfapP-8cN5hVAmwtE'

// {
//   "access_token": "v2.local.1KAxsXAIbpfxgEKlXtWkp1QjRp2IJBkgKKLTDjj51B7Sj_UkO7kJjYwTN_pWlPOX4l5QF68uSR-A0onG-zCvC82GNNScYvo13NLqFJcT4Gi9IETRKeyzz4rxhycBUKNVUvpgVR8tacMeI8H3FHjPTtDGg_jlzt6Y-iogLLaErNdVgVa7gPaS9DbQgrx1_nHOehAQk5OutHUsyi2sJKuYQVa0eVuw1TK-AagDQ2MZHbeU9IzHQCZlouafG8K3uaIi7lBVrI9zd7YwswgpfcplBz6o4TQMShY",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2024-11-09T01:58:03.930934Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2024-11-02T01:57:58+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.1KAxsXAIbpfxgEKlXtWkp1QjRp2IJBkgKKLTDjj51B7Sj_UkO7kJjYwTN_pWlPOX4l5QF68uSR-A0onG-zCvC82GNNScYvo13NLqFJcT4Gi9IETRKeyzz4rxhycBUKNVUvpgVR8tacMeI8H3FHjPTtDGg_jlzt6Y-iogLLaErNdVgVa7gPaS9DbQgrx1_nHOehAQk5OutHUsyi2sJKuYQVa0eVuw1TK-AagDQ2MZHbeU9IzHQCZlouafG8K3uaIi7lBVrI9zd7YwswgpfcplBz6o4TQMShY'

// {
//   "access_token": "v2.local.MAeP3IZOjwenXFFsDFePiuq6KdDrW5cUfDp-_LrcrQ2Nqv3ccSIi9o2pxMxRA11jfpaIOCwV8V9GrWAHsFD7XR1k8i4JVg1HBqvoOh0yMywbKUaIkj2VdcWH5jOo3cONo-M5KGn3cqBfdsJ0HIkXA8l3xfZsiTSOSWves5dhMoA1G5BwmkF85XrLaOMA8lUAx8IDjloex6NNozxflOBOAHy8HHl6ppn7ZLQfUHYWet2JKRE3Rbga37RMZqy68oKeKoDWC_Sh_kCEaxVpdSMtKy3xxSTE",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2024-11-09T01:59:36.543512Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.MAeP3IZOjwenXFFsDFePiuq6KdDrW5cUfDp-_LrcrQ2Nqv3ccSIi9o2pxMxRA11jfpaIOCwV8V9GrWAHsFD7XR1k8i4JVg1HBqvoOh0yMywbKUaIkj2VdcWH5jOo3cONo-M5KGn3cqBfdsJ0HIkXA8l3xfZsiTSOSWves5dhMoA1G5BwmkF85XrLaOMA8lUAx8IDjloex6NNozxflOBOAHy8HHl6ppn7ZLQfUHYWet2JKRE3Rbga37RMZqy68oKeKoDWC_Sh_kCEaxVpdSMtKy3xxSTE'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
